<div class="main-container">
  <div class="image-section">
    <img src="assets/icons/playground-process.svg" alt="process">
  </div>
  <div class="info-section">
    <div class="info-title">
      Test Queued!
      <div class="info-subtitle">
        Queued tests will start once the in progress ones finish running. </div>
    </div>
  </div>
